<div class="csv-wrap">
  <div class="tips error-tips flex-v-center" *ngIf="result.errors!.length>0">
    <i></i>
    <ul>
      <li *ngFor="let item of result.errors; let i = index">{{item}}</li>
    </ul>
  </div>
  <div class="csv-wrap-content  w-full p-8 h-[678px] flex sm:flex-col">
    <!-- [nzShowUploadList]="true"
    [nzFileList]="fileList" [nzMultiple]="false" -->
    <div class="csv-wrap-content-left">
      <nz-upload 
      *ngIf="!isUploaded"
      nzType="drag"
      [nzMultiple]="false"
      [nzAction]="'/eshop_backend/shoppingCart/export'"
      (nzChange)="importFile($event)"
      [nzBeforeUpload]="beforeUpload"
      [nzFileList]="fileList"
      [nzRemove]="removeFile"
    >
      <p class="ant-upload-drag-icon">
        <i class="upload"></i>
      </p>
      <p class="ant-upload-text"> {{ "CSV/EXCEL_UPLOAD_TIPS" | translate }}</p>
      </nz-upload>
      <div class="flex-center upload-list-wrap" *ngIf="isUploaded">
        <div class="upload-list flex-between">
          <div class="flex-v-center">
            <svg-icon class="cursor-pointer"  [iconName]="'File.svg'" [size]="40"></svg-icon>
            <div class="excel">
              <div >{{file.name}}</div>
              <div class="size" *ngIf="file">{{ fileSize  }} KB</div>
            </div>
          </div>
          <div><svg-icon class="cursor-pointer"  [iconName]="'close-file.svg'" [size]="16" (click)="removeFile()"></svg-icon></div>
        </div>
      </div>
    </div>
    <div class="csv-wrap-content-right mx:w-[392px] sm:w-full mx:pl-8 sm:px-0 sm:py-4">
      <div class="csv-wrap-content-right-title flex-v-center">
        <svg-icon [iconName]="'new/template.svg'" class="mr-2"></svg-icon>
        <span class="font-bold">{{ "TEMPLATE" | translate }}</span>
      </div>
      <div class="my-6">
        <span>{{"CSV_DESC" | translate}}</span>
        <span>{{"CSV_DESC_NON_BOSCH_SEPARATOR" | translate}}</span>
        <span class="non-bosch-desc">{{"CSV_DESC_NON_BOSCH" | translate}}</span>
      </div>
      <div class="w-full mb-6">
        <img  src="assets/template_svg.svg" width="100%"/>
      </div>
      <div class="csv-wrap-content-right-download" >
        <div class="flex-v-center" (click)="downloadCSV('cart.csv')">
          <svg-icon [iconName]="'new/download.svg'" class="mr10"></svg-icon>
          <span>{{ "DOWNLOAD_CSV_TEMPLATE" | translate }}</span>
        </div>
        <div class="flex-v-center" (click)="downloadCSV('cart_template.xlsx')">
          <svg-icon [iconName]="'new/download.svg'"  class="mr10"></svg-icon>
          <span> {{ "DOWNLOAD_EXCEL_TEMPLATE" | translate }}</span>
        </div>
      </div>
    </div>
    
  </div>
</div>
